module.exports = "/_next/static/images/f4e2393c32766067b011b4b287b34016-savings-xs.jpg.webp";